export default "__VITE_ASSET__gulKQkfF__"